/**
 * Price component
 *
 * @module price-component
 * @version 1.0.0
 * @extends HTMLElement
 */
class priceComponent extends HTMLElement {
  /**
   * Product price web component.
   *
   * @constructor
   */
  constructor() {
    super();

    this.metafields = window.theme.productMetafields;

    this.initEvents();
  }

  /**
   * Init events.
   *
   * @returns {undefined}
   */
  initEvents() {
    // On variant change
    window.addEventListener("variant-change", this.onVariantChange.bind(this));
  }

  /**
   * On variant change.
   *
   * @param {object} event Event.
   * @returns {undefined}
   */
  onVariantChange(event) {
    if (event.detail.product.handle == this.dataset.handle) {
      this.update(event.detail.variant);
    }
  }

  /**
   * Update price.
   *
   * @returns {undefined}
   */
  update(variant) {
    if (variant) {
      this.querySelector("[data-price]").innerHTML = theme.money.format(
        variant.price
      );

      // let priceInAtcElement = document.getElementById("priceinatc");

      // if (priceInAtcElement) {
      //   priceInAtcElement.innerHTML = theme.money.format(variant.price);
      // } else {
      //   console.warn("Element with ID 'priceinatc' not found.");
      // }

      // console.log("priceinatc: " + priceinatc);

      // let product_custom_discount_percent = variant.price / (1 - ( 0.01 * custom_discount_percent ));
      // console.log(theme.money.format((Math.round(product_custom_discount_percent/100)*100)-1));

      // this.querySelector('[data-compareAtPriceMetafield]').innerHTML = theme.money.format((Math.round(product_custom_discount_percent/100)*100)-1);

      let compareAtPrice = this.querySelector("[data-compareatprice]");

      if (compareAtPrice) {
        if (variant.compare_at_price) {
          compareAtPrice.innerHTML = theme.money.format(
            variant.compare_at_price
          );
        } else {
          compareAtPrice.innerHTML = "";
        }
      }
    }
  }
}

customElements.define("price-component", priceComponent);
